define('views/modules/calendar/favorite/edit/favorite-edit-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/menu/menu-save-action',
    'views/modules/calendar/favorite/edit/form/favorite-edit-form',
    // templates
    'text!templates/modules/calendar/favorite/edit/favorite-edit-content.html'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VMenuSaveAction,
    VFavoriteForm,
    // templates
    TFavoriteEditContent
) {

    var VFavoriteEditContent = Backbone.View.extend({

        template: TFavoriteEditContent,

        regions: {
            root: ".favorite-edit-content",
            menu: ".menu-actions",
            form: ".favorite-edit-form",
        },

        initialize: function(opt) {
            opt = opt || {};

            var view = this.view = {
                menu: new VMenuSaveAction({
                    context: this,
                    onClick: this.onActionClick,
                    onSave: this.onSaveButton,
                    tooltip: {
                        container: this.regions.root,
                    }
                }),
                form: new VFavoriteForm({
                    model: this.model,
                    item: opt.item
                })
            };

            this.listenTo(view.form, {
                'model:change': this.onModelChange,
                'form:success': this.onSuccess
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.form, zone.$form);

            return this;
        },

        ////////////
        // events //
        ////////////

        onActionClick: function(e) {
            e.preventDefault();
        },

        onModelChange: function(isDirty) {
            this.view.menu.toggleSaveButton(!isDirty);
        },

        onSaveButton: function() {
            this.view.form.submit();
        },

        onSuccess: function(model) {
            this.trigger('form:success', model);
        },

    });

    return VFavoriteEditContent;

});

